export default __webpack_public_path__ + "static/video_still_journey-5de0383d2085474c27ebec89b21556d7.jpg";